import { Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLoadTenderExpressProfile extends Layout {
    checkboxIncludeCustomers: Checkbox;
    checkboxIncludeDest: Checkbox;
    checkboxIncludeOrig: Checkbox;
    checkboxIncludePartners: Checkbox;
    checkboxIncludeRevenue: Checkbox;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelMinutes: Label;
    labelRefreshTenderExpressgridevery: Label;
    panel1: Panel;
    panelLeftSide: Panel;
    panelRightSide: Panel;
    sourceEdiLtxexpressProf: DataSource;
    switchIncludeEmpty: Switch;
    switchIncludeEmptyDest1: Switch;
    switchIncludecanceltenders: Switch;
    switchIncludechangetenders: Switch;
    switchIncludeoriginaltenders: Switch;
    switchIncludetendersmarkedforexclusion: Switch;
    switchIncludetenderswhichdonotneedreplies: Switch;
    switchMyProfile: Switch;
    switchUseexpressmodewhencreatingorders: Switch;
    textboxCustomerIds: Textbox;
    textboxDateRange: Textbox;
    textboxDaysPrevious: Textbox;
    textboxDestType: Textbox;
    textboxDestZones: Textbox;
    textboxId: Textbox;
    textboxIntercompanyFilter: Textbox;
    textboxOrigType: Textbox;
    textboxOrigZones: Textbox;
    textboxPartnerIds: Textbox;
    textboxPartnerStatus: Textbox;
    textboxRefreshRate: Textbox;
    textboxRevenueCodes: Textbox;
    textboxTitle: Textbox;
}
